import { useEffect, useRef, useState } from 'react';
import MultiSelectContainer from '../../global-components/multiSelectContainer';
import { fetchCarriersList } from '../../../api/carriers';
import { useLocation } from 'react-router-dom';

interface Props {
  formData: any;
  setFormData: any;
  userSetting?: any;
}

function CarriersSelect({ formData, setFormData, userSetting }: Props) {
  const location = useLocation();
  const [carriersList, setCarriersList] = useState<any>([]);
  const [selectedCarrierList, setSelectedCarrierList] = useState<any>([]);
  const [nonselectedCarrierList, setNonSelectedCarrierList] = useState<any>([]);
  const hasEffectRun = useRef(false);

  function fetchCarriers() {
    fetchCarriersList({ is_pagination: false })
      .then((response: any) => {
        if (!response?.data?.is_error) {
          const allCarriers = response.data.content;

          const selectedCarriers = allCarriers
            .filter(
              (carrier: any) =>
                carriersList && carriersList.includes(carrier.code)
            )
            .map((carrier: any) => ({
              id: carrier.code,
              label: carrier.mode_name,
              name: carrier.name,
            }));

          setSelectedCarrierList(selectedCarriers);

          if (!carriersList || carriersList.length === 0) {
            const allCarriersAsNonSelected = allCarriers.map(
              (carrier: any) => ({
                id: carrier.code,
                label: carrier.mode_name,
                name: carrier.name,
              })
            );
            setNonSelectedCarrierList(allCarriersAsNonSelected);
          } else {
            const nonSelectedCarriers = allCarriers
              .filter((carrier: any) => !carriersList.includes(carrier.code))
              .map((carrier: any) => ({
                id: carrier.code,
                label: carrier.mode_name,
                name: carrier.name,
              }));
            setNonSelectedCarrierList(nonSelectedCarriers);
          }
        }
      })
      .catch((e) => {});
  }

  useEffect(() => {
    if (!hasEffectRun.current && formData !== undefined) {
      let codes =
        formData?.fullCarriers && formData?.fullCarriers.length > 0
          ? formData?.fullCarriers.map((carrier: any) => carrier.code)
          : [];
      setCarriersList(codes);
      hasEffectRun.current = true;
      // if (codes !== undefined && codes.length > 0) {
      //   setCarriersList(codes);
      //   hasEffectRun.current = true;
      // }
      if (location.pathname === '/app/admin/accounts/add') {
        setCarriersList(codes);
        hasEffectRun.current = true;
      }
    }
    // if (formData?.carriers?.length === 0) {
    //   hasEffectRun.current = true;
    // }
  }, [formData]);

  useEffect(() => {
    if (hasEffectRun.current) {
      fetchCarriers();
    }
  }, [carriersList]);

  useEffect(() => {
    if (hasEffectRun.current) {
      const selectedCarriersIds =
        selectedCarrierList &&
        selectedCarrierList.map((carrier: any) => carrier.id);
      setFormData({
        ...formData,
        carriers: selectedCarriersIds,
      });
    }
  }, [selectedCarrierList]);

  return (
    <div>
      <MultiSelectContainer
        selectedList={selectedCarrierList}
        nonSelectedList={nonselectedCarrierList}
        setSelectedList={setSelectedCarrierList}
        setNonSelectedList={setNonSelectedCarrierList}
        userSetting={userSetting}
      />
    </div>
  );
}

export default CarriersSelect;
